import React from 'react';
import { Helmet } from 'react-helmet';

// Copy is governed by docs/A2P_SMS_COMPLIANCE.md §2 — update the doc first.
const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto p-10 sm:p-20 max-w-3xl">
      <Helmet>
        <title>Privacy Policy — Build Construx, Inc</title>
      </Helmet>

      <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">
        Build Construx, Inc &middot; Effective Date: July 29, 2026
      </p>

      <p className="mb-6">
        Build Construx, Inc ("Company," "we," "our," or "us") values your privacy and is committed
        to protecting your personal information. This Privacy Policy describes how we collect, use,
        and protect your information when you visit our website or opt in to receive communications
        from us.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">1. Information We Collect</h2>
      <p className="mb-3">We may collect the following information:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>First Name and Last Name</li>
        <li>Phone Number</li>
        <li>Email Address</li>
        <li>Service or Property Address</li>
        <li>Any information submitted through contact or inquiry forms</li>
      </ul>

      <h2 className="text-xl font-bold mt-8 mb-3">2. How We Use Your Information</h2>
      <p className="mb-3">We use your information to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Schedule project consultations and on-site assessments</li>
        <li>Provide project scheduling and installation status updates</li>
        <li>Send estimates and invoice notifications</li>
        <li>Respond to service inquiries and customer support requests</li>
        <li>Send promotional offers and new product announcements (if you opt in)</li>
        <li>Improve our services</li>
      </ul>

      <h2 className="text-xl font-bold mt-8 mb-3">3. SMS Communications</h2>
      <p className="mb-3">
        If you consent to receive SMS messages from Build Construx, Inc, you may receive messages
        related to:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Appointment confirmations and reminders</li>
        <li>Project scheduling updates</li>
        <li>Installation status updates</li>
        <li>Estimate follow-ups and invoice notifications</li>
        <li>Promotional offers, new product announcements, and free estimate announcements</li>
      </ul>
      <p className="mb-4">
        Message frequency may vary. <strong>Message and data rates may apply.</strong>
      </p>
      <p className="mb-4">
        You may opt out at any time by replying <strong>STOP</strong>. For assistance, reply{' '}
        <strong>HELP</strong>.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">4. Non-Sharing Clause</h2>
      <p className="mb-4">
        <strong>
          No mobile information will be shared or sold to third parties or affiliates for marketing
          or promotional purposes.
        </strong>{' '}
        Information sharing to subcontractors in support services, such as customer service, CRM
        platforms, and messaging providers, is permitted. All other use case categories exclude
        text messaging originator opt-in data and consent; this information will not be shared with
        any third parties.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">5. Data Protection</h2>
      <p className="mb-4">
        We implement reasonable security measures to protect your personal information from
        unauthorized access, misuse, or disclosure.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">6. Third-Party Services</h2>
      <p className="mb-4">
        We may use third-party service providers to support our business operations, including
        hosting providers, CRM systems, and messaging platforms. These providers are authorized to
        use your information only as necessary to provide services on our behalf.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">7. Your Rights</h2>
      <p className="mb-4">
        You may request access to, correction of, or deletion of your personal information by
        contacting us at:
      </p>
      <address className="not-italic mb-4">
        <strong>Build Construx, Inc.</strong>
        <br />
        Email:{' '}
        <a href="mailto:hello@buildconstrux.com" className="underline">
          hello@buildconstrux.com
        </a>
        <br />
        Website:{' '}
        <a href="https://buildconstrux.com" className="underline">
          buildconstrux.com
        </a>
      </address>

      <h2 className="text-xl font-bold mt-8 mb-3">8. Contact Us</h2>
      <address className="not-italic mb-8">
        <strong>Build Construx, Inc.</strong>
        <br />
        Email:{' '}
        <a href="mailto:hello@buildconstrux.com" className="underline">
          hello@buildconstrux.com
        </a>
        <br />
        Website:{' '}
        <a href="https://buildconstrux.com" className="underline">
          buildconstrux.com
        </a>
      </address>
    </div>
  );
};

export default PrivacyPolicy;
